import { isEmail } from 'validator'
import { includes } from 'lodash'
import { INVALID_DOMAINS } from 'constants/InvalidEmailDomains'

export const emailHasInvalidDomain = (email) => INVALID_DOMAINS.some(domain => includes(email, domain))
export const isEmailValid = (email) => isEmail(email) && email.length > 0



// WEBPACK FOOTER //
// ./src/utils/email.js